import { useCallback } from 'react'
import { WHATSAPP_MAIN } from '../config'
import { useLanguage } from '../contexts/LanguageContext'
import { useLead } from '../contexts/LeadContext'
import { trackWhatsAppContact } from '../tracking'

/**
 * Every WhatsApp entry point on the page goes through here: it builds the prefilled
 * message in the visitor's language and opens the single shared line.
 *
 * If WHATSAPP_MAIN is empty the controls render disabled — a placeholder number is
 * never used as a fallback.
 */
export function useWhatsApp() {
  const { t } = useLanguage()
  const { leadName, vehicleInterest, hasSubmitted } = useLead()

  const buildMessage = useCallback((): string => {
    if (!hasSubmitted || !leadName) return t('picker.msg.generic')
    const vehicleLabel = vehicleInterest
      ? t(`form.opt.${vehicleInterest}`).toLowerCase()
      : t('form.opt.not-sure').toLowerCase()
    return t('picker.msg.named', { name: leadName, vehicle: vehicleLabel })
  }, [hasSubmitted, leadName, vehicleInterest, t])

  const open = useCallback(
    (context: string) => {
      if (!WHATSAPP_MAIN) return
      // The line is shared, so the tracked "queen" is the shared inbox, not a person.
      trackWhatsAppContact('Shared line', context)
      const url = `https://wa.me/${WHATSAPP_MAIN}?text=${encodeURIComponent(buildMessage())}`
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    [buildMessage],
  )

  return { available: Boolean(WHATSAPP_MAIN), open }
}
